"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallDutyRovers = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const SpaceType_1 = require("../../SpaceType");
const Resources_1 = require("../../Resources");
const Units_1 = require("../../Units");
const Size_1 = require("../render/Size");
const MoonCard_1 = require("./MoonCard");
const Card_1 = require("../Card");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const TileType_1 = require("../../TileType");
class SmallDutyRovers extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.SMALL_DUTY_ROVERS,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.SPACE],
            cost: 9,
            reserveUnits: Units_1.Units.of({ titanium: 1 }),
            tr: { moonLogistics: 1 },
            metadata: {
                description: 'Spend 1 titanium. Raise the Logistic Rate 1 step. Gain 1 M€ per colony tile, mine tile and road tile on the Moon.',
                cardNumber: 'M73',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.minus().titanium(1).moonLogisticsRate().br;
                    b.megacredits(1).slash().nbsp(Size_1.Size.SMALL)
                        .moonColony().any
                        .moonMine().any
                        .moonRoad().any;
                }),
            },
        });
    }
    ;
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true, false, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        super.play(player);
        MoonExpansion_1.MoonExpansion.raiseLogisticRate(player);
        const gain = this.computeBonus(player);
        player.addResource(Resources_1.Resources.MEGACREDITS, gain, { log: true });
        return undefined;
    }
    getActionDetails(player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, moonLogisticsRateIncrease: 1, bonusMegaCredits: this.computeBonus(player) });
    }
    computeBonus(player) {
        const moonData = MoonExpansion_1.MoonExpansion.moonData(player.game);
        let gain = moonData.moon.spaces.filter((s) => s.tile !== undefined && s.spaceType !== SpaceType_1.SpaceType.COLONY).length;
        if (moonData.moon.spaces.some((s) => { var _a; return ((_a = s.tile) === null || _a === void 0 ? void 0 : _a.tileType) === TileType_1.TileType.LUNAR_MINE_URBANIZATION; })) {
            gain++;
        }
        if (player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr))
            gain += 2;
        return gain;
    }
}
exports.SmallDutyRovers = SmallDutyRovers;
//# sourceMappingURL=SmallDutyRovers.js.map